import { j as a } from "../../../jsx-runtime-B6kdoens.js";
import { c as n, f as u } from "../../../create-component-CBAeEoQ6.js";
import { Button as f } from "../../Button/index.js";
import { useFooterStateAtoms as i } from "../FooterState/index.js";
import { u as p } from "../../../react-B_GApDuV.js";
const B = n(
  "FooterButton",
  u(
    ({ children: o, className: t, ...r }, e) => {
      const { modeAtom: m } = i(), s = p(m);
      return /* @__PURE__ */ a.jsx(
        f,
        {
          size: "sm",
          ref: e,
          className: t,
          state: s === "dark" ? "brand" : "dark",
          ...r,
          children: o
        }
      );
    }
  )
);
export {
  B as FooterButton
};
//# sourceMappingURL=index.js.map
